import * as React from 'react';
import styled from '@emotion/styled';
import { observer } from 'mobx-react';
import { useNavigate } from 'react-router-dom';
import { SidebarButtonWidget } from '../sidebar/SidebarButtonWidget';
import { Routing } from '../../../pages/Routing';

export interface MainSidebarWidgetProps {
  close: () => any;
}

export const MainSidebarWidget: React.FC<MainSidebarWidgetProps> = observer((props) => {
  const navigate = useNavigate();
  return (
    <S.Container>
      <SidebarButtonWidget
        label="Profiles"
        action={() => {
          navigate(Routing.PROFILES, { replace: true });
          props.close();
        }}
      />
      <SidebarButtonWidget
        label="Packs"
        action={() => {
          navigate(Routing.PACKS, { replace: true });
          props.close();
        }}
      />
      <SidebarButtonWidget
        label="Groups"
        action={() => {
          navigate(Routing.GROUPS, { replace: true });
          props.close();
        }}
      />
    </S.Container>
  );
});
namespace S {
  export const Container = styled.div`
    display: flex;
    flex-direction: column;
    min-height: 100%;
    box-sizing: border-box;
    padding: 5px;
  `;
}
